import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DocumentoRecepcionadoDetalleService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    agregaDetalleProductoRecepcionado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
            query ($entidad: documento_recepcionadoInputType, $detalle: documento_recepcionado_detalleInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
              documento_recepcionado_detalle {
                agregaDetalleProductoRecepcionado(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                  mensajes{
                    codigo
                    contexto
                    tipo
                    texto
                  }
                  respuesta {
                    paginaActual
                    cantidadRegistrosPorPagina
                    totalPaginas
                    totalRegistros
                    registros {
                      rut_receptor
                      rut_emisor
                      tipo_dte_codigo
                      tipo_item_nombre
                      folio
                      nro_linea
                      producto_proveedor
                      producto_proveedor_descripcion
                      formato_codigo
                      formato_nombre
                      factor_equivalencia
                      producto_codigo
                      sku
                      producto_descripcion
                      formato_codigo_top
                      formato_nombre_top
                      cantidad_recibida
                      desc_es_porcentaje
                      descuento
                      rec_es_porcentaje
                      recargo
                      es_activo_fijo
                      tipo_item_codigo
                      impuesto_codigo
                      total_linea
                      precio_unitario
                      equivalencia_producto_id
                      producto_valido
                    }
                  }
                }
              }
            }
            `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_recepcionado_detalle.agregaDetalleProductoRecepcionado;
            callback({ mensajes, respuesta });
        });
    }
    agregaDetalleProductoSinSKURecepcionado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: documento_recepcionadoInputType, $detalle: documento_recepcionado_detalleInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recepcionado_detalle {
            agregaDetalleProductoSinSKURecepcionado(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  tipo_item_nombre
                  folio
                  nro_linea
                  producto_proveedor
                  producto_proveedor_descripcion
                  formato_codigo
                  formato_nombre
                  factor_equivalencia
                  producto_codigo
                  sku
                  producto_descripcion
                  formato_codigo_top
                  formato_nombre_top
                  cantidad_recibida
                  desc_es_porcentaje
                  descuento
                  rec_es_porcentaje
                  recargo
                  es_activo_fijo
                  tipo_item_codigo
                  impuesto_codigo
                  total_linea
                  precio_unitario
                  equivalencia_producto_id
                  producto_valido
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_recepcionado_detalle.agregaDetalleProductoSinSKURecepcionado;
            callback({ mensajes, respuesta });
        });
    }
    agregaDetalleCorrecionMontoNCRecepcionado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: documento_recepcionadoInputType, $detalle: documento_recepcionado_detalleInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recepcionado_detalle {
            agregaDetalleCorrecionMontoNCRecepcionado(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  tipo_item_nombre
                  folio
                  nro_linea
                  producto_proveedor
                  producto_proveedor_descripcion
                  formato_codigo
                  formato_nombre
                  factor_equivalencia
                  producto_codigo
                  sku
                  producto_descripcion
                  formato_codigo_top
                  formato_nombre_top
                  cantidad_recibida
                  desc_es_porcentaje
                  descuento
                  rec_es_porcentaje
                  recargo
                  es_activo_fijo
                  tipo_item_codigo
                  impuesto_codigo
                  total_linea
                  precio_unitario
                  equivalencia_producto_id
                  producto_valido
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_recepcionado_detalle.agregaDetalleCorrecionMontoNCRecepcionado;
            callback({ mensajes, respuesta });
        });
    }
    UpdateDetalleProductoRecepcionado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: documento_recepcionadoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recepcionado_detalle {
            actualizarDetalleNotaCredito(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  folio
                  nro_linea
                  producto_proveedor
                  producto_proveedor_descripcion
                  formato_codigo
                  formato_nombre
                  factor_equivalencia
                  producto_codigo
                  sku
                  producto_descripcion
                  formato_codigo_top
                  formato_nombre_top
                  cantidad_recibida
                  cantidad_diferencia
                  desc_es_porcentaje
                  descuento
                  rec_es_porcentaje
                  recargo
                  es_activo_fijo
                  tipo_item_codigo
                  impuesto_codigo
                  total_linea
                  subtotal
                  precio_unitario
                }
              }
            }
          }
        }
            `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_recepcionado_detalle.actualizarDetalleNotaCredito;
            callback({ mensajes, respuesta });
        });
    }
}
DocumentoRecepcionadoDetalleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentoRecepcionadoDetalleService_Factory() { return new DocumentoRecepcionadoDetalleService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DocumentoRecepcionadoDetalleService, providedIn: "root" });
